import { useIdleTimer } from 'react-idle-timer';

export const SESSION_IDLE_TIMEOUT_MS = 30 * 60_000;

export type UseIdleSignOutArgs = {
  isAuthenticated: boolean;
  /** App-specific sign-out (e.g. POST to the app's sign-out route, clear cookies, redirect). */
  onSignOut: () => void | Promise<void>;
  /** Called instead of `onSignOut` when an anonymous session goes idle. */
  onAnonymousIdle?: () => void;
  timeout?: number;
};

/**
 * Signs authenticated guests out after a period of inactivity, synced across tabs.
 */
export function useIdleSignOut({
  isAuthenticated,
  onSignOut,
  onAnonymousIdle,
  timeout = SESSION_IDLE_TIMEOUT_MS,
}: UseIdleSignOutArgs) {
  useIdleTimer({
    timeout,
    crossTab: true,
    syncTimers: 1000,
    onIdle: () => {
      if (isAuthenticated) {
        void onSignOut();
        return;
      }
      onAnonymousIdle?.();
    },
  });
}
